import React, { useMemo } from 'react';
import useTranslation from '~/app/hooks/useTranslation';
import classes from './style.module.scss';

export interface DescriptionProps {
    description: string;
}

export type DescriptionComponent = React.FC<DescriptionProps>;

const Description: DescriptionComponent = ({ description }) => {
    const { t } = useTranslation('workorder');

    const body = useMemo(() => {
        const text = description?.trim();
        return text || '-';
    }, [description]);

    return (
        <div className={classes['card']}>
            <h2 className={classes['title']}>{t('detail.description')}</h2>
            <p className={classes['body']}>{body}</p>
        </div>
    );
};

export default Description;
